import _ from 'lodash';
import React from 'react';

import {useFilteredProjectPickerQueryQuery} from './../../generated/graphql';
import {useViewer} from './../../state/viewer/hooks';

export interface ProjectData {
  id: string;
  name: string;
  entityName: string;
  createdAt: string;
  internalId?: string;
}

export const useProjectOptions = ({
  entityName,
  queryString,
}: {
  entityName: string;
  queryString: string;
}) => {
  const viewer = useViewer();
  const {data, loading} = useFilteredProjectPickerQueryQuery({
    variables: {
      entityName,
      userName: viewer?.username ?? '',
      pattern: queryString,
    },
  });

  const entityProjects = data?.entity?.projects?.edges.map(e => e.node) ?? [];
  const viewerProjects = data?.viewer?.projects?.edges.map(e => e.node) ?? [];
  const userProjects =
    data?.user?.teams?.edges.flatMap(edge =>
      edge.node?.projects?.edges.map(e => e.node)
    ) ?? [];

  let projects = userProjects
    .concat(viewerProjects)
    .concat(entityProjects)
    .map(
      proj =>
        ({
          ...proj,
          createdAt: proj?.createdAt.toString(),
        } as ProjectData)
    )
    .filter(proj => !!proj);
  projects = _.uniqBy(projects, p => p.id);
  projects = _.sortBy(projects, p => p.createdAt);
  projects = _.reverse(projects);

  return React.useMemo(
    () => ({
      loading,
      projects,
    }),
    [projects, loading]
  );
};
